import { Table } from "components";
import { LoadingOrEmptyWrapper } from "components/LoadingAndEmptyHandler";

// TODO: Replace with getTableTypicalColumn type when it's ts
type GroupTableHeader = {
  dataKey: string;
  isInDefault: boolean;
  label: string;
  valueTransformation: (row: Record<string, unknown>) => unknown;
};

type TechnicalConfigGroupTableProps<Row extends Record<string, unknown>> = {
  columnsMinWidth?: string;
  editable?: (row: Row) => boolean;
  groups: Row[];
  headers: GroupTableHeader[];
  idColumnName: keyof Row & string;
  isLoading: boolean;
  onBlur?: (params: { fieldName: string; row: Row; value: string }) => void;
  onDelete: (group: Row) => void;
  rowRemoveable: (row: Row) => boolean;
};

export const TechnicalConfigGroupTable = <Row extends Record<string, unknown>>({
  columnsMinWidth,
  editable = () => false,
  groups,
  headers,
  idColumnName,
  isLoading,
  onBlur,
  onDelete,
  rowRemoveable,
}: TechnicalConfigGroupTableProps<Row>) => {
  return (
    <LoadingOrEmptyWrapper showEmpty={groups.length === 0} showLoading={isLoading}>
      <Table
        columnsMinWidth={columnsMinWidth}
        data={groups}
        editable={editable}
        headers={headers}
        idColumnName={idColumnName}
        onBlur={onBlur}
        onDelete={({ row }: { row: Row }) => onDelete(row)}
        rowRemoveable={rowRemoveable}
      />
    </LoadingOrEmptyWrapper>
  );
};
